import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedSpecialPopulations = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add a Special Populations"
    okText="ADD A SPECIAL POPULATIONS"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose a special populations:"
      queryVariables={{ typeId: FILTER_TYPE.SPECIAL_POPULATIONS.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Special populations is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedSpecialPopulations.Item = Item;

export default RelatedSpecialPopulations;
